module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("确认发票信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '发票抬头不能为空'
      }],
      "label": "发票抬头",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.row.fapiao_taitou),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_taitou", $$v)
      },
      expression: "row.fapiao_taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '税号不能为空'
      }],
      "label": "税号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.row.fapiao_shuihao),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_shuihao", $$v)
      },
      expression: "row.fapiao_shuihao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如果您所在的单位没有纳税人识别号请填写“无”")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "发票备注",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入发票备注"
    },
    model: {
      value: (_vm.row.fapiao_beizhu),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_beizhu", $$v)
      },
      expression: "row.fapiao_beizhu"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "接送邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接送邮箱"
    },
    model: {
      value: (_vm.row.fapiao_email),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_email", $$v)
      },
      expression: "row.fapiao_email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "接送手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接送手机"
    },
    model: {
      value: (_vm.row.fapiao_phone),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_phone", $$v)
      },
      expression: "row.fapiao_phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fapiao-tip-wrap"
  }, [_c('div', [_vm._v("\n                    发票1 金额：" + _vm._s(parseInt(_vm.row.order.memberprice) + parseInt(_vm.row.order.otherprice)) + "元  名目：赛事综合服务费\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.order.shisuprice > 0),
      expression: "row.order.shisuprice>0"
    }]
  }, [_vm._v("\n                    发票2 金额：" + _vm._s(_vm.row.order.shisuprice) + "元  名目：食宿费\n                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "10px"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中...",
      "native-type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确认发票信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc05af7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiApplyFapiao.vue
// module id = 1274
// module chunks = 0